import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import logger from "../logger/logger";
import { initialFormData } from "../data/inputData"
import { PrimaryButtonStyled, SecondaryButtonStyled, SimpleButtonStyled } from "../styles/Button";
import { ErrorMessageStyled, FormNavContainerStyled, InputStyled } from "../styles/Form";
import { TableStyled, TableHeaderStyled, TableDataStyled, TableRowStyled } from '../styles/Table';
import { PageHeader2Styled, PageHeaderSubTextMobileStyled, PageHeaderSubTextStyled } from "../styles/Main";
import InputDescriptions from "./InputDescriptions";


const MultiPageInputsForm = ({ mode, inputType, formData, setFormData, handleIncrementFormStep, handleDecrementFormStep, errors, isMobile }) => {
    const [showInputDescriptions, setShowInputDescriptions] = useState(false);
    const formPrimaryZip = {...formData[Object.keys(formData)[0]]}

    useEffect(() => {
        if(mode==='manual' && inputType==='property_details' && Object.keys(formData).length===0) {
            const newFormData = {123: JSON.parse(JSON.stringify(initialFormData))}
            setFormData(newFormData)
            console.log(formData);
            
        }
    }, [mode, inputType, setFormData, formData])
    
    const generalInputs = Object.fromEntries(
        Object.entries(formPrimaryZip).filter(([key, value]) => (
          (mode==='manual' && (!value.type.includes('capex') && value.type === inputType)) || 
          (mode==='zip' && (!value.type.includes('capex') && value.type === inputType && value.showOnZip))
        ))
    )

    const displayTitle = () => {
      const titleArr = inputType.split('_')
      let newTitle = ''
      titleArr.forEach((word) => {
        let capitalWord = word.charAt(0).toUpperCase() + word.slice(1)
        newTitle = newTitle + ' ' + capitalWord
      })
      return newTitle
    }

    const displayInputs = () => {
        return Object.keys(generalInputs).map((item) => (

          <TableRowStyled key={item}>
            <TableDataStyled $size={45}>
              {generalInputs[item].displayName}
            </TableDataStyled>
            <TableDataStyled $size={55}>
              <InputStyled
                type="number"
                pattern="[0-9]*"
                placeholder={!isMobile?`Enter ${generalInputs[item].displayName}`:`${generalInputs[item].displayName}`}
                value={formPrimaryZip[item].value || ""}
                onChange={(e) => handleChange(item, e.target.value)}
                aria-label={`Input for ${generalInputs[item].displayName}`}
              />
            </TableDataStyled>
            <>
              {
                !isMobile?
                <TableDataStyled>{generalInputs[item].desc || ""}</TableDataStyled>:
                <></>
              }
            </>
          </TableRowStyled>
        ))
      }
      
      const handleChange = (field, value) => {
        formPrimaryZip[field] = { ...formPrimaryZip[field], "value": value }
        let newFormData = { ...formData };
        newFormData[Object.keys(formData)[0]] = formPrimaryZip
        setFormData(newFormData);
        logger.debug(`Form field updated: ${field} with value ${value}`);    
      };
  
    return (
        
        
            <div>
              {
                showInputDescriptions?
                <InputDescriptions inputs={generalInputs} type={'general'} setShowInputDescriptions={setShowInputDescriptions}/>:
                <div>
                  <PageHeader2Styled>{displayTitle()}</PageHeader2Styled>   
                  <>
                    {
                    isMobile?
                    <>
                      <PageHeaderSubTextMobileStyled>{`Please enter the values for the ${inputType.replace('_', ' ')} items`}</PageHeaderSubTextMobileStyled>
                      <SimpleButtonStyled onClick={() => setShowInputDescriptions(1)}>Show Input Details</SimpleButtonStyled>
                    </>:
                    <PageHeaderSubTextStyled>{`Please enter the values for the ${inputType.replace('_', ' ')} items`}</PageHeaderSubTextStyled>
                    }
                    
                  </>
                  <TableStyled>
                      <thead>
                      <TableRowStyled>
                          <TableHeaderStyled>Property Details</TableHeaderStyled>
                          <TableHeaderStyled $size={55}>Input</TableHeaderStyled>
                          {!isMobile?<TableHeaderStyled $size={55}>Description</TableHeaderStyled>:<></>}
                      </TableRowStyled>
                      </thead>
                      <tbody>
                      {displayInputs()}
                      </tbody>
                  </TableStyled>
                  <div>
                    {errors.length > 0 ? 
                        <div>
                          {errors.map(((error, i) => (
                            <ErrorMessageStyled key={i}>{error.message}</ErrorMessageStyled>
                          )))}
                        </div>:
                        <></>
                    }
                  </div>
                  <FormNavContainerStyled>
                    <SecondaryButtonStyled onClick={handleDecrementFormStep}>Back</SecondaryButtonStyled>
                    <PrimaryButtonStyled onClick={handleIncrementFormStep}>Next</PrimaryButtonStyled>
                  </FormNavContainerStyled>
                </div>
              }
            </div>
    );
};

MultiPageInputsForm.propTypes = {
  mode: PropTypes.string.isRequired, 
  inputType: PropTypes.string.isRequired, 
  handleIncrementFormStep: PropTypes.func.isRequired, 
  handleDecrementFormStep: PropTypes.func.isRequired, 
  formData: PropTypes.object.isRequired, 
  setFormData: PropTypes.func.isRequired
};

export default MultiPageInputsForm;